import { injectable } from 'inversify';
import 'reflect-metadata';

import { del, get, post, put } from '@api/api-client';

@injectable()
export class CrudService<T, ResBody = T, Res = ResBody>
  implements ICrudService<T, ResBody, Res>
{
  protected modelName: string = '';
  protected tableName: string = '';

  find() {
    return get<ResBody[]>(`${PUBLIC_API_URL}/${this.tableName}`);
  }
  findOneById(id: number | string) {
    return get<Res>(`${PUBLIC_API_URL}/${this.tableName}/${id}`);
  }
  create(data: Partial<T>) {
    // @ts-ignore
    return post<Res>(`${PUBLIC_API_URL}/${this.tableName}`, data);
  }
  update(id: number | string, data: Partial<T>) {
    // @ts-ignore
    return put<Res>(`${PUBLIC_API_URL}/${this.tableName}/${id}`, data);
  }
  // patchUpdate(id: number, data: Partial<T>) {
  //   return patch<Res>(`${PUBLIC_API_URL}/${this.tableName}/${id}`);
  // }
  delete(id: number | string) {
    return del<Res>(`${PUBLIC_API_URL}/${this.tableName}/${id}`);
  }
}

export interface ICrudService<T, ResBody = T, Res = ResBody> {
  find(): Promise<ResBody[]>;
  findOneById(id: number | string): Promise<Res>;
  create(data: Partial<T>): Promise<Res>;
  update(id: number | string, data: Partial<T>): Promise<Res>;
  // patchUpdate(id: number, data: Partial<T>): Promise<Res>;
  delete(id: number | string): Promise<Res>;
}
